<template>
    <div class="mb-3">
        <component style="display: none" :is="show_document"></component>

        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol>
                                <strong>{{ $t('purchaseReport') }}</strong>
                            </CCol>
                          <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">

                            <CButton
                                class="mr-1"
                                size="sm"
                                @click="print_with_header_title_height(body_id,header_id,footer_id,$t('SaleInvoiceReports'),100,100)"
                                color="secondary"
                            >{{ $t("buttons.print") }}
                            </CButton>
                          </CCol>

                        </CRow>
                      <CRow style="justify-content: center;" v-if="selected_type==1">
                       <strong>
                         {{selected_invoice.partyCode}} - {{selected_invoice.partyName}}
                       </strong>
                      </CRow>
                        <CRow v-if="selected_type==0">
                            <CCol col="3">
                                <date-picker

                                        :label="$t('components.startDate')"
                                        v-model="start_date"></date-picker>
                            </CCol>
                            <CCol col="3">
                                <date-picker
                                        :label="$t('components.endDate')"
                                        v-model="end_date"></date-picker>

                            </CCol>
                            <!--              <CCol  col="2">-->
                            <!--                <CSelect :value.sync="selected_type"-->
                            <!--                         :options="[{label:$t('all'),value:0},{label:$t('invoice'),value:1}]"-->
                            <!--                />-->
                            <!--              </CCol>-->


                            <CCol col="3">
                                <CSelect
                                        :label="$t('PaymentStatus')"
                                        :horizontal="{label: 'col-sm-6', input: 'col-sm-6'}"

                                        :value.sync="selected_pay_type"
                                        :options="pay_type_items"
                                />
                            </CCol>
<!--                            <CCol>-->
<!--                                <CSelect-->
<!--                                        :label="$t('PaidStatus')"-->
<!--                                        :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"-->
<!--                                        :value.sync="selected_paid_type"-->
<!--                                        :options="paid_type_items"-->
<!--                                />-->
<!--                            </CCol>-->
                            <CCol col="1">
                                <CButton @click="get_all_data" color="dark"
                                         size="sm">
                                    <CIcon size="sm" name="cil-zoom"/>
                                </CButton>
                            </CCol>
                            <!--              <CCol col="1" v-if="selected_type==1">-->
                            <!--                <CButton @click="get_invoice_report" color="dark"-->
                            <!--                         size="sm">-->
                            <!--                  <CIcon size="sm" name="cil-zoom"/>-->
                            <!--                </CButton>-->
                            <!--              </CCol>-->

                            <!--              <CCol col="3">-->
                            <!--                <CSelect :value.sync="selected_paid_type"-->
                            <!--                         :options="paid_type_items"-->
                            <!--                />-->
                            <!--              </CCol>-->

                        </CRow>
                        <CRow v-if="selected_type==1">
                            <CCol col="1">
                                <CButton @click="selected_type=0" color="dark"
                                         size="sm">
                                    <CIcon size="sm" name="cil-arrow-left"/>
                                </CButton>
                            </CCol>
                        </CRow>

                    </CCardHeader>
                    <CCardBody :id="body_id">

                        <CDataTableFixed
                                v-if="selected_type==0"
                                :items="items_sell_filtered"
                                :fields="fields"
                                :column-filter="get_filter_table"
                                @row-clicked="table_row_clicked"
                                :pagination="get_pagination"

                                :items-per-page="20"
                                hover
                                sorter
                                border
                                striped
                                :sorter-value="{column:'recId',asc:false}"

                        >
                            <template #row="{item,index}">

                                <td>
                                    <p style="text-align: center">{{ index + 1 }}</p>

                                </td>

                            </template>
                            <template #createdAt="{item}">

                                <td>
                                    <p class="text-center">{{ get_date(item.createdAt) }}</p>

                                </td>

                            </template>
                            <template #partyCode="{item}">

                                <td>
                                    <p class="text-center">{{ item.partyCode }}</p>

                                </td>

                            </template>


                            <template #masterCode="{item}">
                                <td>
                                  <a :href="'/dashboard/documents/show/' + item.recId" target="_blank">
                                    <p class="text-center text-primary">{{ item.masterCode }}</p>

                                  </a>
                                </td>

                            </template>
                            <template #totalPrice="{item}">
                                <td>
                                    <p v-if="item.totalPrice!=null" class="text-right">{{
                                        get_currency(item.totalPrice.replace(/,/g, "")) }}</p>
                                </td>
                            </template>
                            <template #balance="{item}">
                                <td>
                                    <p class="text-right">{{ item.balance}}</p>
                                </td>
                            </template>
                            <template #partyName="{item}">

                                <td>
                                    <p>{{ item.partyName }}</p>

                                </td>

                            </template>

                            <template #user="{item}">

                                <td>
                                    <p>{{ item.createdBy }}</p>

                                </td>

                            </template>
                            <template #payType="{item}">
                                <td>
                                    <p style="text-align: center">{{ item.payType }}</p>
                                </td>
                            </template>
                            <template #statusPay="{item}">
                                <td>
                                    <p style="text-align: center">{{ item.statusPay }}</p>
                                </td>
                            </template>



                            <template #operation="{item}">
                                <td>

                                    <CButton v-if="item.statusId ==0"

                                             size="sm"
                                             :title="$t('buttons.finalize')"
                                             @click="Finalize(item)"
                                    >
                                        <CIcon name="cil-trash" class="text-danger"/>
                                    </CButton>


                                </td>
                            </template>


                            <template #select="{item}">
                                <td>
                                    <CCol v-if="item.isReorder ==null ">

                                        <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                                               :value="item.recId"/>

                                    </CCol>

                                </td>
                            </template>
                          <template #caption>
                              <tr class="total-table">
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>{{$t('totalPrice')}}</td>
                                  <td>{{get_currency(calculate_items(items_sell_filtered,'totalPrice'))}}</td>
                                  <td></td>
                                  <td></td>
<!--                                  <td></td>-->
                              </tr>
                          </template>
                        </CDataTableFixed>
                        <CDataTableFixed
                                v-if="selected_type==1"
                                :items="items_invoice"
                                :fields="fields_invoice"
                                :column-filter="get_filter_table"
                                :items-per-page="20"
                                hover
                                :pagination="get_pagination"

                                border
                                striped

                        >
                            <template #row="{item,index}">

                                <td>
                                    <p class="text-center">{{ index + 1 }}</p>

                                </td>

                            </template>
                            <template #createdAt="{item}">

                                <td>
                                    <p class="text-center">{{ get_date(item.createdAt) }}</p>

                                </td>

                            </template>

                            <template #balance="{item}">
                                <td>
                                    <!--                  <p v-if="item.amount>item.amountNegetive" style="text-align:right">{{ get_currency(item.accBalance) }}</p>-->
                                    <!--                  <p v-else style="text-align:right">{{ get_currency(item.accBalanceNegetive) }}</p>-->
                                    <p class="text-right">{{ get_currency(item.balance) }}</p>

                                </td>
                            </template>

                            <template #amount="{item}">
                                <td>
                                    <p class="text-right" v-if="item.amount>0">{{ get_currency(item.amount) }}</p>
                                    <p class="text-right" v-else>0</p>
                                </td>
                            </template>
                            <template #amountNegetive="{item}">
                                <td>
                                    <p class="text-right" v-if="item.amount<0">{{ get_currency(Math.abs(item.amount)) }}</p>
                                    <p class="text-right" v-else>0</p>
                                </td>
                            </template>
                            <template #partyName="{item}">

                                <td>
                                    <p>{{ item.partyName }}</p>

                                </td>

                            </template>
                            <template #toziKonande="{item}">

                                <td>
                                    <p v-if="item.toziKonande!=null">{{ item.toziKonande }}</p>

                                </td>

                            </template>
                            <template #user="{item}">
                                <td>
                                    <p>{{ item.createdBy }}</p>
                                </td>
                            </template>
                            <template #masterCode="{item}">
                                <td>
                                    <p class="text-center">{{ item.masterCode }}</p>
                                </td>
                            </template>


                            <template #operation="{item}">
                                <td>

                                    <CButton v-if="item.statusId ==0"

                                             size="sm"
                                             :title="$t('buttons.finalize')"
                                             @click="Finalize(item)"
                                    >
                                        <CIcon name="cil-trash" class="text-danger"/>
                                    </CButton>


                                </td>
                            </template>

                            <template #select="{item}">
                                <td>
                                    <CCol v-if="item.isReorder ==null ">

                                        <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                                               :value="item.recId"/>

                                    </CCol>

                                </td>
                            </template>
                            <template #under-table>
                                <CRow>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol>{{ $t('totalCirculation') }}</CCol>
                                    <CCol>{{ get_currency(calculate_items(items_invoice.filter(x=>x.amount>0),'amount')) }}</CCol>
                                    <CCol>{{ get_currency(calculate_items(items_invoice.filter(x=>x.amount<0),'amount')) }}</CCol>
                                    <CCol></CCol>

                                </CRow>
                                <CRow>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol class="bg-dark">{{ $t('tables.balance') }}</CCol>
                                    <CCol class="bg-dark">{{ get_currency( calculate_items(items_invoice,'amount')) }}
                                    </CCol>
                                    <CCol></CCol>

                                    <CCol></CCol>
                                </CRow>

                            </template>

                        </CDataTableFixed>
                    </CCardBody>

                </CCard>
            </CCol>
        </CRow>
      <div v-show="false" :id="header_id" style="margin-right: 50px;margin-left: 50px;margin-bottom: 70px">
        <CCol>
          <CRow style="justify-content:center">
            <strong style="font-size: large">{{get_bussiness_name()}}</strong>
          </CRow>

          <CRow style="justify-content:center">
            <strong>{{$t('SaleInvoiceReports')}}</strong>
          </CRow>
          <CRow>
            <CCol >
              <label>{{$t('FromDate')}} {{get_date(start_date)}}</label>
            </CCol>
            <CCol style="text-align:center" >
              <label >{{$t('UpToDate')}} {{get_date(end_date)}}</label>
            </CCol>
            <CCol style="text-align:end" >
              <label >{{$t('PreparedDate')}} {{get_date(get_today())}}</label>
            </CCol>
          </CRow>
          <CRow>
            <CCol>
              <label v-if="selected_city!=0">{{city_items.filter(x=>x.cityId == selected_city)[0].cityName}} ,</label>
              <label v-if="selected_district!=0">{{district_items.filter(x=>x.id == selected_district)[0].title}} ,</label>
              <label v-if="selected_route!=0">{{route_items.filter(x=>x.id == selected_route)[0].title}}</label>

            </CCol>
          </CRow>
        </CCol>

      </div>
      <div v-show="false" :id="footer_id" class="border-dark">
        <CCardHeader>
          <CRow style="border: 1px solid #797979">


            <CCol sm="4" md="4" style="text-align: start">
              <h5>{{ $t('docCreator') }} : {{ get_user_name() }}</h5>
            </CCol>
            <CCol sm="4" md="4" style="text-align: center">
              <h6 id="pageFooter" class="pageFooter"></h6>
            </CCol>
            <CCol sm="4" md="4" style="text-align: end">
              <h6>
              </h6>
            </CCol>
          </CRow>

        </CCardHeader>

      </div>
        <CModal
                color="dark"
                size="lg"
                :show.sync="invoice_info"
        >
            <CDataTableFixed
                    :items="items_invoice"
                    :fields="fields_invoice"
                    :items-per-page="200"
                    hover

                    border
                    striped

            >
                <template #row="{item,index}">

                    <td>
                        <p class="text-center">{{ index + 1 }}</p>

                    </td>

                </template>
                <template #docDate="{item}">

                    <td>
                        <p class="text-center">{{ get_date(item.docDate) }}</p>

                    </td>

                </template>

                <template #balance="{item}">
                    <td>
                        <!--                  <p v-if="item.amount>item.amountNegetive" style="text-align:right">{{ get_currency(item.accBalance) }}</p>-->
                        <!--                  <p v-else style="text-align:right">{{ get_currency(item.accBalanceNegetive) }}</p>-->
                        <p class="text-right text-danger" v-if="item.balance>0">{{ get_currency(Math.abs(item.balance)) }}</p>
                        <p class="text-right" v-else>{{ get_currency(Math.abs(item.balance)) }}</p>

                    </td>
                </template>

                <template #amount="{item}">
                    <td>
                        <p class="text-right">{{ get_currency(item.amount) }}</p>
                    </td>
                </template>
                <template #amountNegetive="{item}">
                    <td>
                        <p class="text-right">{{ get_currency(item.amountNegetive) }}</p>
                    </td>
                </template>
                <template #partyName="{item}">

                    <td>
                        <p>{{ item.partyName }}</p>

                    </td>

                </template>
                <template #toziKonande="{item}">

                    <td>
                        <p v-if="item.toziKonande!=null">{{ item.toziKonande }}</p>

                    </td>

                </template>
                <template #user="{item}">
                    <td>
                        <p>{{ item.createdBy }}</p>
                    </td>
                </template>
                <template #masterCode="{item}">
                    <td>
                        <p class="text-center">{{ item.masterCode }}</p>
                    </td>
                </template>


                <template #operation="{item}">
                    <td>

                        <CButton v-if="item.statusId ==0"

                                 size="sm"
                                 :title="$t('buttons.finalize')"
                                 @click="Finalize(item)"
                        >
                            <CIcon name="cil-trash" class="text-danger"/>
                        </CButton>


                    </td>
                </template>

                <template #under-table>
                    <CRow>
                        <CCol></CCol>
                        <CCol></CCol>
                        <CCol></CCol>
                        <CCol></CCol>
                        <CCol></CCol>
                        <CCol>{{ $t('totalCirculation') }}</CCol>
                        <CCol>{{ get_currency(calculate_items(items_invoice,'amountNegetive')) }}</CCol>
                        <CCol>{{ get_currency(calculate_items(items_invoice,'amount')) }}</CCol>
                        <CCol></CCol>

                    </CRow>
                    <CRow>
                        <CCol></CCol>
                        <CCol></CCol>
                        <CCol></CCol>
                        <CCol></CCol>
                        <CCol></CCol>
                        <CCol class="bg-dark">{{ $t('tables.balance') }}</CCol>
                        <CCol class="bg-dark text-danger" v-if="calculate_items(items_invoice,'amountNegetive')
                - calculate_items(items_invoice,'amount')<0">{{ get_currency(Math.abs(calculate_items(items_invoice,'amountNegetive')
                            - calculate_items(items_invoice,'amount'))) }}
                        </CCol>
                        <CCol class="bg-dark" v-else>{{ get_currency(calculate_items(items_invoice,'amountNegetive')
                            - calculate_items(items_invoice,'amount')) }}
                        </CCol>
                        <CCol></CCol>

                        <CCol></CCol>
                    </CRow>

                </template>

            </CDataTableFixed>

            <template #footer>
                <CButton @click="invoice_info = false" color="danger">{{$t('buttons.close')}}</CButton>
            </template>
        </CModal>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'

    const simulateAsyncOperation = fn => {
        setTimeout(fn, 200)
    }
    var items_data = [];


    export default {
        name: 'Login',
        components: {
            Treeselect,
            'test-dynamic': () => import('../documents/PrintDocument'),

        },
        data() {
            return {
                invoice_info:false,
                items_invoice: [],
                fields_invoice: [
                    {key: 'row', label: this.$t('tables.sharp'), sorter: false, _style: 'width:2%;text-align:center'},
                    {key: 'docDate', label: this.$t('tables.date'), _style: 'width:10%'},
                    {key: 'statusTitle', label: this.$t('tables.documentType'), _style: 'width:10%'},
                    {key: 'accNo', label: this.$t('docNumber'), _style: 'width:10%'},
                    {key: 'masterCode', label: this.$t('referenceNo'), _style: 'width:10%'},
                    {key: 'amount', label: this.$t('bedehkar'), _style: 'width:10%'},
                    {key: 'amountNegetive', label: this.$t('bestankar'), _style: 'width:10%'},
                    {key: 'balance', label: this.$t('tables.balance'), _style: 'width:10%'},
                ],
              header_id: "print_report_header_sale_invoice" + new Date().getTime() + this.$vnode.tag,
              footer_id: "print_report_footer_sale_invoice" + new Date().getTime() + this.$vnode.tag,
              body_id: "print_report_body_sale_invoice" + new Date().getTime() + this.$vnode.tag,
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                show_document: 'test-dynamic',
                printed_doc_id: 0,
                name: '',
                selected_invoice: 0,
                start_date: '',
                end_date: '',
                submit_refer: 0,
                refer_person: null,
                selected_template: 0,
                id_checkbox_items: [],
                item_sell_array: [],
                paid_type_items: [],
                selected_paid_type: 0,
                selected_type: 0,
                pay_type_items: [],
                selected_pay_type: 0,
                items_sell_filtered: [],
                items_sell: [],
                table_clicks_timer: '',
                table_clicks: 0,

                fields: [
                    {key: 'row', label: this.$t('tables.sharp'), sorter: false, _style: 'width:2%;text-align:center'},
                    {key: 'masterCode', label: this.$t('tables.factorId'), _style: 'width:10%;text-align:center'},
                    {key: 'createdAt', label: this.$t('tables.date'), _style: 'width:10%'},
                    {key: 'partyCode', label: this.$t('supplierCode'), _style: 'width:8%'},
                    {key: 'partyName', label: this.$t('supplierName'), _style: 'width:15%'},
                    {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'width:10%'},
                    // {key: 'balance', label: this.$t('tables.balance'), _style: 'width:10%'},
                    {
                        key: 'payType',
                        label: this.$t('PaymentStatus'),
                        _style: 'width:10%',
                        sorter: false,
                        filter: false
                    },
                    // {key: 'statusPay', label: this.$t('PaidStatus'), _style: 'width:10%', sorter: false, filter: false},
                    {key: 'createdBy', label: this.$t('docCreator'), _style: 'width:10%'},

                ],


                route_items: [],
                selected_route: 0,

                area_items: [],
                selected_area: 0,

                province_items: [],
                selected_province: 0,

                city_items: [],
                selected_city: 0,

                district_items: [],
                selected_district: 0,

                country_items: [],
                selected_country: 0,

                details: [],

                status_form: 0,
                load_persons({action, searchQuery, callback}) {
                    var self = this;

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);

                            axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
                    }
                },

            }
        }, mounted() {

            this.start_date = this.get_day_before_today_in_day(4);
            this.end_date = this.get_today();

            this.$root.root_validate_errors = [];

            this.get_all_data();
            this.get_sys();
            this.get_country()
            this.get_routes()
            this.get_all_data()
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
            bus.$on("delete_re_order_called", (data) => {
                this.get_all_data();
            });

        }, watch: {
            '$route.params.person_id': function () {
                this.get_all_data();
            },
            'start_date': function () {
                // this.get_all_data();
            },
            'end_date': function () {
                // this.get_all_data();
            },
            'selected_paid_type': function () {
                if (this.selected_paid_type == 0) {
                    this.items_sell_filtered = this.items_sell.filter(x => x.statusId == 1);

                } else {
                    this.items_sell_filtered = this.items_sell.filter(x => x.statusId == 1 && parseInt(x.statusPayId) == this.selected_paid_type);
                }
            },
            'selected_pay_type': function () {
                if (this.selected_pay_type == 0) {
                    this.items_sell_filtered = this.items_sell.filter(x => x.statusId == 1);
                } else {
                    this.items_sell_filtered = this.items_sell.filter(x => x.statusId == 1 && parseInt(x.payTypeId) == this.selected_pay_type);
                }
            },
            'selected_province': function () {
                this.get_cities();
            },
            'selected_city': function () {
                this.get_districts();
            },
            'selected_district': function () {
                this.get_areas();
            },
            'selected_country': function () {
                this.get_provinces();
            },
        },
        methods: {
            get_invoice_report(item) {

                var self = this;
                var formData = new FormData();

                var url = "GetPersonAccountsByFactorId";

                // formData.append("FromDate", self.get_day_before_today_in_day(365));
                // formData.append("ToDate", self.get_today());
                formData.append('FactorId', this.selected_invoice.recId);
                // formData.append('FactorId', 3667);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    if (content_data.statusCode == 0) {

                        self.items_invoice = content_data.data.personAccountItems.map((item, row_id) => {
                            return {...item, row_id}
                        });
                        var last_balance = 0;
                        self.items_invoice.forEach(function (val) {
                            val.balance = last_balance + parseFloat(val.amount) ;
                            if(parseFloat(val.amount)<0){
                                val.amountNegetive = Math.abs(parseFloat(val.amount))
                                val.amount = 0;
                            }else{
                                val.amountNegetive = 0
                            }
                            last_balance = val.balance;
                        });
                        self.invoice_info=true;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });


            },

            get_country() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetCountries', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.country_items = [];

                        self.country_items = self.sort_array(
                            self.country_items, content_data.data,
                            'id', 'title');

                        if (self.$i18n.locale == 'fa') {
                            self.selected_country = self.country_items.filter(x => x.label == 'ایران')[0].value
                        }
                        if (self.$i18n.locale == 'en') {
                            self.selected_country = self.country_items.filter(x => x.label == 'England')[0].value
                        }

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_provinces() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_country);


                axios.post('GetStateList', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.province_items = [];
                        self.province_items.push({label: self.$t('dialogs.insertProvince'), value: 0});

                        self.province_items = self.sort_array(
                            self.province_items, content_data.data,
                            'id', 'provinceName');


                        self.selected_province = self.province_items[0].value;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_cities() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_province);

                axios.post('GetCityListByStateId', formData, {show_pros: true}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.city_items = []
                        self.city_items = self.sort_array(
                            self.city_items, content_data.data,
                            'cityId', 'cityName');

                        self.selected_city = self.city_items[0].value;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_districts() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_city);

                axios.post('GetRegionByCityId', formData, {show_pros: true}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.district_items = []
                        self.district_items = self.sort_array(
                            self.district_items, content_data.data,
                            'id', 'title');

                        self.selected_district = self.district_items[0].value;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_areas() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_district);

                axios.post('GetAreaTitlesByCityId', formData, {show_pros: true}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.area_items = []
                        self.area_items = self.sort_array(
                            self.area_items, content_data.data,
                            'id', 'areaName');

                        // content_data.data.forEach((val) => {
                        //   var obj = {label: val.areaName, value: val.id}
                        //
                        //   self.area_items.push(obj);
                        // });
                        self.selected_area = self.area_items[0].value;
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_routes() {
                var self = this;

                const formData = new FormData();

                axios.post('GetRoutesNew', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.route_items = [{label: self.$t('all'), value: 0}]
                        self.route_items = self.sort_array(self.route_items, content_data.data, 'id', 'title')
                        self.selected_route = self.route_items[0].value;


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            get_sys() {
                var self = this;

                const formData = new FormData();

                axios.post('GetSysPersonGlobals', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;

                    self.paid_type_items = [];
                    var obj = {label: self.$t('all'), value: 0}

                    self.paid_type_items.push(obj);
                    self.pay_type_items.push(obj);

                    content_data.forEach((val) => {
                        var obj = {label: val.title, value: val.id}

                        if (val.titleType == 28) {
                            self.paid_type_items.push(obj);
                        }
                        if (val.titleType == 26) {
                            self.pay_type_items.push(obj);
                        }
                    });


                    self.selected_paid_type = self.paid_type_items[0].value


                }).catch(function (error) {

                    console.log(error);
                });

            },
            table_row_clicked(item, index) {

                this.table_clicks++;
                if (this.table_clicks == 1) {
                    this.table_clicks_timer = setTimeout(() => {
                        // this.result.push(event.type);
                        this.table_clicks = 0
                    }, 500);
                } else if (this.table_clicks > 1) {
                    clearTimeout(this.table_clicks_timer);
                    this.table_clicks = 0
                    // this.selected_type = 1;
                    this.selected_invoice = item;
                    // this.goShowDocument(item)
                    this.get_invoice_report();
                }

            },
            get_all_data() {
                this.get_lists_sell();

            },

            get_lists_sell() {

                var self = this;
                var formData = new FormData();

                var url = "GetDocsByParams";
                formData.append("DocType", 1);
                if (self.$route.params.person_id != null) {
                    formData.append("PersonId", self.$route.params.person_id);
                } else {
                    formData.append("PersonId", 0);
                }

                // formData.append("id", 3);

                formData.append("FirstDate", self.start_date);
                formData.append("SecondDate", self.end_date);
                formData.append('CountryId', this.selected_country);
                formData.append('CityId', this.selected_city);
                formData.append('ProvinceId', this.selected_province);
                formData.append('RegionId', this.selected_district);
                formData.append('AreaId', this.selected_area);
                formData.append('RouteId', this.selected_route);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    if (content_data.statusCode == 0) {

                        self.items_sell = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                        self.items_sell_filtered = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                        self.items_sell = self.items_sell.filter(x => x.statusId == 1)
                        self.items_sell_filtered = self.items_sell.filter(x => x.statusId == 1)

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });


            },
            get_invoice_report_old() {

                var self = this;
                var formData = new FormData();

                var url = "GetPersonAccountsByFactorId";

                // formData.append("FromDate", self.start_date);
                // formData.append("ToDate", self.end_date);
                formData.append('FactorId', this.selected_invoice.recId);
                // formData.append('FactorId', 3667);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    if (content_data.statusCode == 0) {

                        self.items_invoice = content_data.data.personAccountItems.map((item, row_id) => {
                            return {...item, row_id}
                        });
                        var last_balance = 0;
                        self.items_invoice.forEach(function (val) {
                            val.balance = last_balance + parseFloat(val.amount);
                            last_balance = val.balance;
                        });

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });


            },

            Finalize(item) {
                var self = this;


                const formData = new FormData();

                var url = "AddFactorToFinal";

                formData.append("id", item.recId);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.$root.modal_component.show_api_response_modals(response);

                    if (content_data.statusCode == 0) {
                        item.statusId = 1;
                    } else {
                        // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            send_to_customer(item) {
                var self = this;


                const formData = new FormData();

                var url = "SendFactorToTelegramBoth";

                formData.append("id", item.recId);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.$root.modal_component.show_api_response_modals(response);

                    if (content_data.statusCode == 0) {
                        item.statusId = 1;
                    } else {
                        // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            goReturnDocument(item) {
                this.$router.push({
                    path: '/dashboard/documents/return/' + item.recId + "/false",
                    params: {passed_data: "salam hamidddd"}
                });
            },
            goShowDocument(item) {
// if(item.isReorder==3){
                // this.$router.push({path: '/dashboard/documents/show/' + item.recId});
// }else{
                this.$router.push({path: '/dashboard/documents/show/' + item.recId});
// }
            },
            goPrintDocument(item) {
                bus.$emit("print_confirm", item.recId);


            },
            AddRefer(item) {
                this.submit_refer = item.recId;
            },

            AddAllRefer() {
                this.submit_refer = -1;
                if (this.id_checkbox_items.length == 0) {
                    console.log("validate form is false" + this.validate_errors);
                    this.submit_refer = 0;

                }
            },

            AddReOrder() {
                if (this.id_checkbox_items.length > 0) {
                    for (var i = 0; i < this.id_checkbox_items.length; i++) {
                        this.add_factor_to_reorder(this.id_checkbox_items[i]);
                    }
                }
            },

            add_factor_to_reorder(id) {
                let self = this;


                let url;
                // if (this.status_form == 0) {
                url = "AddReOrder";
                // }
                const formData = new FormData();

                formData.append('Id', id);

                axios.post(url, formData, {}).then((res) => {


                    self.submit_refer = 0;
                    if (self.id_checkbox_items[self.id_checkbox_items.length - 1] == id) {
                        self.id_checkbox_items = [];
                        self.$root.modal_component.show_api_response_modals(res);
                        bus.$emit('reorder_added')
                    }
                    self.get_all_data();


                })
                    .catch(function (error) {

                        console.log(error);
                    });
            },

            insert_refer() {
                let self = this;

                if (this.submit_refer != -1) {


                    this.id_checkbox_items = [];
                } else {
                    if (this.id_checkbox_items.length == 0) {
                        console.log("validate form is false" + this.validate_errors);
                        self.submit_refer = 0;
                        self.id_checkbox_items = [];

                        return true;
                    }

                }
                if (this.refer_person == null) {
                    console.log("validate form is false" + this.validate_errors);

                    return true;
                }
                let url;
                // if (this.status_form == 0) {
                url = "AddFactorRefer";
                // }
                if (this.submit_refer != -1) {
                    const formData = new FormData();

                    formData.append('PersonId', this.refer_person);

                    formData.append('MasterFactorId', this.submit_refer);
                    axios.post(url, formData, {}).then((res) => {


                        self.submit_refer = 0;
                        self.id_checkbox_items = [];

                        self.refer_person = null;

                        self.$root.modal_component.show_api_response_modals(res);
                        self.get_all_data()
                    })
                        .catch(function (error) {

                            console.log(error);
                        });
                } else {
                    self.id_checkbox_items.forEach((val) => {

                        const formData = new FormData();

                        formData.append('PersonId', this.refer_person);

                        formData.append('MasterFactorId', val);
                        axios.post(url, formData, {}).then((res) => {


                        })
                            .catch(function (error) {

                                console.log(error);
                            });
                    });
                    self.id_checkbox_items = [];
                    self.submit_refer = 0;
                    self.id_checkbox_items = [];

                    self.refer_person = null;

                    this.get_all_data()
                }


            },

        },

    }

</script>
